import OwlCarousel from 'react-owl-carousel';
import moment from 'moment';
import ResortInfo from '~/js/components/specials/last-minute-deals/resort-info.js';
import Calendar from '~/js/components/specials/last-minute-deals/calendar.js';

const { Component } = React;
const internals = {};

internals.sliderOptions = {
  className: 'owl-theme',
  lazyLoad: true,
  nav: false,
  items: 3,
  dots: false,
  stageOuterClass: 'owl-stage-outer calendars-container',

  responsive: {
    768: {
      items: 2,
      dots: true,
    },
    1199: {
      items: 3,
      dots: false,
    }
  },
};

export default class ResortCalendars extends Component {

    static defaultProps = {
      resortSummary: {},
      cdnURL: '#',
    }

    constructor(props) {
      super(props);


      this.numberOfDaysStay = 0;
      this.daysOfStay = 0;
      this.checkOuts = [];
      this.state = {calendars: this.getCalendars()};
    }

    getCalendars = () => {
      const { resortSummary: { rstCode = '' }, setPopup } = this.props;
      const calendars = [];
      let currentDate = moment();

      for (let index = 0; index < 3; index++) {
        currentDate = moment(currentDate).add(1, 'M');
        let month = currentDate.month();
        let year = currentDate.year();

        if (currentDate.month() === 0) {
          month = 12;
          year = year - 1;
        }

        const key = rstCode + month + year;
        const firstDayOfMonth = new Date(`${month}/1/${year}`).getDay();
        const calendar = this.getMonth(month, year, firstDayOfMonth);

        calendars.push(
          <div key={key} className="slide-container">
            <Calendar
              firstDayOfMonth={firstDayOfMonth}
              monthName={moment(month, 'M').format('MMMM')}
              year={year}
              calendar={calendar}
              calendarKey={key}
              setPopup={setPopup}
              rstCode={rstCode}
            />
          </div>
        );
      }

      return (
        <OwlCarousel {...internals.sliderOptions}>
          {calendars}
        </OwlCarousel>
      );
    }

    getMonth(currentMonth, currentYear, firstDayOfMonth) {
      let calendar = [];
      const daysInMonth = moment(`${currentYear}-${currentMonth}`, 'YYYY-M').daysInMonth();

      for (let index = 0; index < daysInMonth + firstDayOfMonth; index += 7) {
        calendar = calendar.concat(this.getWeek(index, firstDayOfMonth, daysInMonth, currentMonth, currentYear));
      }

      return calendar;
    }

    addDate({type = 'blank', checkIn = '',  checkOuts = []}) {
      return {type, checkIn, checkOuts};
    }

    getWeek(firstDateOfWeek, firstDayOfMonth, daysInMonth, month, year) {
      const week = [];

      for (let index = 0; index < 7; index++) {
        const currentDate = firstDateOfWeek + index - firstDayOfMonth + 1;

        if(currentDate > daysInMonth || (firstDateOfWeek === 0 && firstDayOfMonth > index)) {
          week.push(this.addDate({}));
        } else {
          if (this.daysOfStay > 0 ) { this.daysOfStay -= 1; }
          week.push(this.getDay(currentDate, month, year));
        }
      }

      return week;
    }

    getDay(currentDate, month, year) {
      const { resortDeals } = this.props;
      const monthKey = `month_${month}`;
      let checkInDate = moment();
      let restDays = [];

      if(monthKey in resortDeals) {
        restDays = resortDeals[monthKey].sort((item1, item2) => item2.numberOfDaysStay - item1.numberOfDaysStay).reduce((matchedDeals, deal) => {
          checkInDate = moment(deal.stayDateLow);
          if(checkInDate.date() === currentDate) {
            const checkOut = moment(deal.stayDateLow)
              .add(deal.numberOfDaysStay, 'day');

            this.checkOuts.push(checkOut.format('MM/DD/YYYY'));
            matchedDeals.push(deal.numberOfDaysStay + 1);
            this.numberOfDaysStay = deal.numberOfDaysStay;
          }

          return matchedDeals;
        }, []);
      }

      if(restDays.length !== 0) {
        const highestNumOfStayDays = restDays.reduce((highest, stayDays) => {
          return stayDays > highest ? stayDays : highest;
        }, 0);

        if(highestNumOfStayDays > this.daysOfStay) {
          this.daysOfStay = highestNumOfStayDays;
        }
      }

      if(this.daysOfStay > this.numberOfDaysStay) {
        checkInDate = moment(`${year}-${month}-${currentDate}`, 'YYYY/M/D');
        const minCheckOutDate = checkInDate.clone().add(this.numberOfDaysStay-1, 'day');

        this.checkOuts = this.checkOuts.filter(checkOut => moment(checkOut, 'MM/DD/YYYY').isAfter(minCheckOutDate)).reverse();;

        return {type: 'checkIn', checkIn: checkInDate.format('MM-DD-YYYY'), checkOuts: [...this.checkOuts]};
      }

      if(this.daysOfStay > 0) { return {type: 'rest'}; }
         this.daysOfStay = 0;
      return {type: 'number'};
    }

    render() {
      const { resortSummary, cdnURL } = this.props;
      return (
         
        <div id={resortSummary.rstCode} className="view-book-resorts">
          <ResortInfo cdnURL={cdnURL} resortSummary={resortSummary} />
          <div className="view-book-date">
            <div className="view-book-date-top">
                    Select check-in date:
              <div className="legend-container">
                <span className="check-in">Check-In Date</span>
                <span className="rest-stay">Rest of Stay</span>
              </div>
            </div>
            <div className="view-book-calendars">
              {this.state.calendars}
            </div>
          </div>
        </div>
      );
    }
}
